import { createSelector } from '@ngrx/store';
import { selectBasicDataState } from './main.selector';
import { IBasicDataState } from '../reducers';

export const selectAdditionalData = createSelector(
  selectBasicDataState,
  (basicDataState: IBasicDataState) => basicDataState.additionalData,
);
